import axios from 'axios';
import variables from '@/config/variables';
import ResponseError from './ResponseError';

const EXPORT_METHODS = ['get', 'head', 'post', 'delete', 'put'];
const TIMEOUT = 10000;
const makeHeader = (accessToken = localStorage.getItem('access_token')) => ({
});

// Default Axios instance for handling HTTP request
const instance = axios.create({
  baseURL: variables.API_URL,
  timeout: TIMEOUT,
});

// Core API export object
const httpMethods = {
  updateAccessToken(accessToken) {
    instance.defaults.headers = makeHeader(accessToken);
  },
  getHeader: makeHeader,
};
// Add a error resolver to the existing axios function
const resolveError = (error) => {
  if (!navigator.onLine) {
    throw new Error('Application has no access to the internet.', {
      status: 'NO_INTERNET',
    });
  }

  if (error.response) throw new ResponseError(error);
  throw error;
};
EXPORT_METHODS.forEach((method) => {
  httpMethods[method] = (...args) => instance[method](...args).catch(resolveError);
});

export default httpMethods;




// WEBPACK FOOTER //
// ./src/libs/webcall/core.js